import { approvalStatuses } from "./constants";

export const formatKey = key => {
  return key
    ?.replace(/_/g, " ")
    ?.replace(/([A-Z])/g, " $1")
    ?.replace(/^./, str => str.toUpperCase());
};

export const formatValue = (key, value) => {
  if (key.toLowerCase() === "email") {
    return value;
  }

  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  if (key.toLowerCase() === "email") {
    return value;
  }

  if (key.toLowerCase() === "gender") {
    if (value === "Other") {
      return "Non-Binary";
    }
  }

  if (key.toLowerCase() === "phone") {
    return value;
  }

  if (key.toLowerCase() === "approval") {
    return approvalStatuses[value] || "Unknown Status";
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return value;
};

export const maskEmail = email => {
  if (!email) return "N/A";
  const [user, domain] = email.split("@");
  const maskedUser =
    user?.length > 2
      ? user[0] + "*".repeat(user?.length - 2) + user.slice(-1)
      : user[0] + "*";
  return `${maskedUser}@${domain}`;
};

export const formatPhoneNumber = phoneNumber => {
  if (!phoneNumber) return "N/A";
  if (phoneNumber?.length >= 6) {
    const visibleDigits = 3;
    const maskedSection = phoneNumber
      .substring(visibleDigits, phoneNumber?.length - visibleDigits)
      .replace(/\d/g, "*");
    const visiblePart =
      phoneNumber.substring(0, visibleDigits) +
      maskedSection +
      phoneNumber.substring(phoneNumber?.length - visibleDigits);
    return visiblePart;
  }
  return phoneNumber;
};

export const formatEmailAddress = email => {
  if (email && email !== "N/A") {
    const parts = email.split("@");
    const visiblePart = `${parts[0].charAt(0)}***@${parts[1]}`;
    return visiblePart;
  }
  return "N/A";
};
